'use client';

import ReactDOM from 'react-dom';

interface PreconnectLinksProps {
  links: string[];
}

export const PreconnectLinks = ({ links }: PreconnectLinksProps) => {
  links.forEach(link => {
    ReactDOM.preconnect(link);
  });

  return null;
};
